export default __webpack_public_path__ + "static/media/Rectangle44.2bcd2069.png";